import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StyledModal, StyledBody, TopSectionV2, PostButton, PostButtonFeed, PostPopupTop } from '../PhotoAndPostFlow/styles';
import { UserInitialsMain } from '../SocialFeedsV2/styles';
import { ImageUrl } from '../../utils/constants';
import { withTranslation } from 'react-i18next';
import { AdminCloseIcon } from '../../utils/icons';
import { TextAreaWrapper } from './styles';
import { CommonButtonBorder } from '../common/commonStyles';
import { toast } from "react-toastify";
import { SendCustomChallengeNotifications, GetPreviousNotificationDetails, GetPreviousEventNotificationDetails, SendCustomEventNotifications, SendCustomInitiativeNotification, GetCompanyInfo, GetCompanyPreviousNotification } from "../../redux/constants/apiConstants";
import { fetchApi, getInitials } from "../../utils/methods";

const CustomNotification = ({ showModal, onClose, user, id, type, companyInitiativeId, companyId }) => {
  const [notificationText, setNotificationText] = useState('');
  const [getCustomNotification, fetchNotification] = useState({});
  const [showPrevNotification, setPrevNotification] = useState(false);
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(()=>{
    if (type === 'initiative') {
      fetchCompanyInfo();
      fetchInitiativeCustomNotification() ;
      return;
    }
    type === 'event' ? fetchEventCustomNotification()  : fetchCustomNotification()
  },[])


  window.console.log("getCustomNotification",getCustomNotification)

  window.console.log("notificationInitiativenotificationInitiativenotificationInitiativenotificationInitiative")

  const fetchCompanyInfo = async () => {
    if (!companyId) return;
    try {
      const res = await fetchApi(`${GetCompanyInfo}/${companyId}`, 'GET');
      if (res.status === 'success') {
        setCompanyInfo(res?.data?.companyInfo?.[0]);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const containsDefaultPng = (str) => (
    str?.includes("default.png")
  );

  const copyCustomNotification = () => {

    if(type === "initiative"){
      setNotificationText(getCustomNotification);
    }
    else{
      setNotificationText(getCustomNotification?.description);
    }

    setPrevNotification(false)
  }


  const postCustomNotification = async () => {
    let companyId=user?.company_id;
    try {
      const postData = {
        "description": notificationText,  
        "type": "challenge",
        "challenge_id" : id
      }; 
      const res = await fetchApi(
        SendCustomChallengeNotifications+"/"+companyId,
        "POST",
        postData,
        {},
      );
      if (res.message) {
        toast.error(res.message);
      }
      toast.success(res?.data[0]);
      onClose()
    } catch (error) {
      toast.error(error.message);
    }
  };

  const postInitiativeNotification = async () => {
    try {
      const postData = {
        company_initiative_id: companyInitiativeId,
        message: notificationText,
      };
      const res = await fetchApi(SendCustomInitiativeNotification, 'POST', postData, {});
      if (res.message && res.status !== 'success') {
        toast.error(res.message);
        return;
      }
      toast.success(res?.message || 'Notification sent successfully');
      onClose();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const postEventCustomNotification = async () => {
    
    try {
      const postData = {
        "description": notificationText,  
        "type": type,
        "event_id" : id
      }; 
      const res = await fetchApi(
        SendCustomEventNotifications,
        "POST",
        postData,
        {},
      );
      if (res.message) {
        toast.error(res.message);
      }
      toast.success(res?.data[0]);
      onClose()
    } catch (error) {
      toast.error(error.message);
    }
  };

  const fetchCustomNotification = async () => {
    let companyId=user?.company_id;
    try {
      const res = await fetchApi(
        GetPreviousNotificationDetails+"/"+companyId+"/challenge",
        "GET"
      );
      if (res.message) {
        toast.error(res.message);
      }
      fetchNotification(res?.data[0])
      setPrevNotification(res?.data[0]?.description)
    } catch (error) {
      toast.error(error.message);
    }
  };


  const fetchInitiativeCustomNotification = async () => {
    try {

      const res = await fetchApi(
        `${GetCompanyPreviousNotification}?id=${companyInitiativeId}`,
        "GET"
      );

      if (res.status === "success") {
        fetchNotification(res?.data?.message)
        setPrevNotification(res?.data?.message)
      }
      else{
        toast.error(res.message);
      }

    } catch (error) {
      toast.error(error.message);
    }
  };



  const fetchEventCustomNotification = async () => {
    try {
      const res = await fetchApi(
        GetPreviousEventNotificationDetails,
        "GET"
      );
      if (res.message) {
        toast.error(res.message);
      }
      fetchNotification(res?.data[0])
      setPrevNotification(res?.data[0]?.description)
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleChange = (e) => {
    const input = e.target.value;
    // Enforce 150 character limit
    if (input.length <= 300) {
      setNotificationText(input);
      // Auto-resize logic
      e.target.style.height = 'auto';
      e.target.style.height = `${e.target.scrollHeight}px`;
    }
  };

  return (
    <div>
      <StyledModal show={showModal} width="800px">
        <PostPopupTop>
          <div className='heading'>{"Send Custom Notification"}</div>
          <div className='closeIcon' onClick={() => onClose()}>{AdminCloseIcon()}</div>
        </PostPopupTop>
        <div style={{ height: "1px", width: "100%", background: "#EFEFEF", margin: "0" }} />
        <StyledBody>
          <TopSectionV2 background maxHeight="320px" margin="16px 0">
            <div className='user-details'>
              <div className='profile'>
                {type === 'initiative' ? (
                  companyInfo?.header_logo
                    ? <img src={ImageUrl + "/" + companyInfo.header_logo} style={{ width: '100%', height: '100%', objectFit: 'contain',border:'1px solid #DCDCDC',padding:'5px 8px' }} />
                    : <UserInitialsMain font>{getInitials(companyInfo?.company_name)}</UserInitialsMain>
                ) : (
                  !containsDefaultPng(user?.profile_image)
                    ? <img src={ImageUrl + "/" + user?.profile_image} />
                    : <UserInitialsMain font>{`${getInitials(user?.fname)}${getInitials(user?.lname)}`}</UserInitialsMain>
                )}
              </div>
              <div className='privacy-admin'>
                <div className='name'>{type === 'initiative' ? companyInfo?.company_name : user?.fname + " " + user?.lname} </div>
              </div>
            </div>
            <TextAreaWrapper>
              <textarea
                id="inlineAutoTextarea"
                value={notificationText}
                onChange={handleChange}
                rows={notificationText?.length>100?2:1}
                placeholder="Write notification content."
              />
            </TextAreaWrapper>
            <PostButton>
              <div className='emojiIcon'>
              </div>
              <div className='char-count'>
                {notificationText?.length}/300 | C
              </div>
            </PostButton>
            <div style={{ height: "1px", width: "100%", background: "#EFEFEF", margin: "16px 0 16px 0" }} />
            <PostButtonFeed disable={notificationText?.length > 0 ? null : 1} gap="16px">
              {showPrevNotification&&<CommonButtonBorder padding="0px" onClick={()=>copyCustomNotification()}>
                Copy previous notification
              </CommonButtonBorder>}
              <div className='button' onClick={()=>{if(notificationText?.length > 0){ type === 'initiative' ? postInitiativeNotification() : type === 'event' ? postEventCustomNotification() : postCustomNotification()}}}>
                Send Now
              </div>
            </PostButtonFeed>
          </TopSectionV2>
        </StyledBody>
      </StyledModal>
    </div>
  );
};

CustomNotification.propTypes = {
  user: PropTypes.object,
  t: PropTypes.func,
  showModal: PropTypes.bool,
  onClose: PropTypes.func,
  id: PropTypes.number,
  type: PropTypes.string,
  companyInitiativeId: PropTypes.number,
  companyId: PropTypes.number,
};

const mapStateToProps = (state) => ({
  user: state.profileData.user,
});

export default connect(mapStateToProps, null)(withTranslation()(CustomNotification));
